@file:OptIn(InternalResourceApi::class)

package ifaandroid.apps.bland.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.apps.bland.composeapp.generated.resources/"

@delegate:ResourceContentHash(-317_912_413)
internal val Res.font.poppins_bold: FontResource by lazy {
      FontResource("font:poppins_bold", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_168_950_066)
internal val Res.font.poppins_extrabold: FontResource by lazy {
      FontResource("font:poppins_extrabold", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_extrabold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_829_262_043)
internal val Res.font.poppins_light: FontResource by lazy {
      FontResource("font:poppins_light", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_light.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_933_769_947)
internal val Res.font.poppins_medium: FontResource by lazy {
      FontResource("font:poppins_medium", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(992_584_762)
internal val Res.font.poppins_regular: FontResource by lazy {
      FontResource("font:poppins_regular", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(429_221_087)
internal val Res.font.poppins_semibold: FontResource by lazy {
      FontResource("font:poppins_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/poppins_semibold.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("poppins_bold", Res.font.poppins_bold)
  map.put("poppins_extrabold", Res.font.poppins_extrabold)
  map.put("poppins_light", Res.font.poppins_light)
  map.put("poppins_medium", Res.font.poppins_medium)
  map.put("poppins_regular", Res.font.poppins_regular)
  map.put("poppins_semibold", Res.font.poppins_semibold)
}
